/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS python filter api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GroundingConfigurationSchema } from './GroundingConfigurationSchema';
import {
    GroundingConfigurationSchemaFromJSON,
    GroundingConfigurationSchemaFromJSONTyped,
    GroundingConfigurationSchemaToJSON,
} from './GroundingConfigurationSchema';

/**
 * 
 * @export
 * @interface PageConfigurationSchema
 */
export interface PageConfigurationSchema {
    /**
     * 
     * @type {Array<GroundingConfigurationSchema>}
     * @memberof PageConfigurationSchema
     */
    items: Array<GroundingConfigurationSchema>;
    /**
     * 
     * @type {number}
     * @memberof PageConfigurationSchema
     */
    total: number | null;
    /**
     * 
     * @type {number}
     * @memberof PageConfigurationSchema
     */
    page: number | null;
    /**
     * 
     * @type {number}
     * @memberof PageConfigurationSchema
     */
    size: number | null;
    /**
     * 
     * @type {number}
     * @memberof PageConfigurationSchema
     */
    pages?: number | null;
}

/**
 * Check if a given object implements the PageConfigurationSchema interface.
 */
export function instanceOfPageConfigurationSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "size" in value;

    return isInstance;
}

export function PageConfigurationSchemaFromJSON(json: any): PageConfigurationSchema {
    return PageConfigurationSchemaFromJSONTyped(json, false);
}

export function PageConfigurationSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageConfigurationSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GroundingConfigurationSchemaFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'size': json['size'],
        'pages': !exists(json, 'pages') ? undefined : json['pages'],
    };
}

export function PageConfigurationSchemaToJSON(value?: PageConfigurationSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(GroundingConfigurationSchemaToJSON)),
        'total': value.total,
        'page': value.page,
        'size': value.size,
        'pages': value.pages,
    };
}

